
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#8B58FB","d":"M56.432 18.328a6.021 6.021 0 018.358-2.087l1.057.653A5.98 5.98 0 0167.873 25L49.288 56.852a12.928 12.928 0 01-11.283 6.408 1.293 1.293 0 01-1.177-.787 13.233 13.233 0 01.747-11.824l18.856-32.32z"}}),_c('path',{attrs:{"fill":"#B99EF4","d":"M8 39.612a6 6 0 016-6h17.06c4.625 0 7.51 5.01 5.19 9.01l-.44.76a5.998 5.998 0 01-5.19 2.99H14a6 6 0 01-6-6v-.76zM8 57.17a5.89 5.89 0 015.89-5.89h7.245c4.598 0 7.422 5.034 5.026 8.958a5.889 5.889 0 01-5.026 2.82h-7.246A5.889 5.889 0 018 57.17z"}}),_c('path',{attrs:{"fill":"#8B58FB","d":"M8 21.343a5.399 5.399 0 015.399-5.398h28.023c4.274 0 6.853 4.73 4.537 8.322a5.396 5.396 0 01-4.537 2.474H13.398A5.398 5.398 0 018 21.343z"}})])
          )
        }
      }
    